import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useCurrency } from "../Context/CurrencyContext";
import axios from "axios";

const MinPlanPrice = ({ category }) => {
  const [price, setPrice] = useState(null);
  const [cutOffPrice, setCutOffPrice] = useState(null);
 
  const { currency, conversionRate, loading: currencyLoading } = useCurrency();

  const routerLocation = useLocation();
  const fullPath = routerLocation.pathname;

  const slug = fullPath.replace(/^\/|\/$/g, "");

  const parts = slug.split("-");

  const serverIndex = parts.lastIndexOf("server");

  let locationSlug = "";

  if (serverIndex !== -1 && parts.length > serverIndex + 1) {
    locationSlug = parts.slice(serverIndex + 1).join("-");
  }

  useEffect(() => {
    if (category) {
    }
  }, [category]);

  useEffect(() => {
    if (category && currency) {
      fetchMinPrice();
    }
  }, [category, currency]);

  const fetchMinPrice = async () => {
    try {
      const res = await axios.get(
        `${import.meta.env.VITE_BACKEND_API_URL}/admin/get-minimum-plan-price`,
        {
          params: {
            category,
            location: locationSlug,
          },
        }
      );

      setPrice(res.data.minPrice);
      setCutOffPrice(res.data.cutOffPrice);
    } catch (err) {
      console.error("Failed to fetch min price", err);
    }
  };

  if (currencyLoading  || !price) return null;

  const isYearly = 
    category?.toLowerCase() === "microsoft-365" ||
    category?.toLowerCase() === "ssl" ||
    category?.toLowerCase() === "wordpress-hosting";

  const durationLabel = isYearly ? "Yr" : "Mo";

  const calculatePrice = (amount) => {
    return isYearly ? amount * 12 : amount;
  };


  const symbol = currency === "INR" ? "₹" : "$";

  const finalPrice = calculatePrice(price) * conversionRate;
  const finalCutOffPrice = cutOffPrice && calculatePrice(cutOffPrice) * conversionRate;

  const roundedFinalPrice = Math.round(finalPrice);
  const roundedFinalCutOffPrice = finalCutOffPrice && Math.round(finalCutOffPrice);

  const showCutOffPrice = roundedFinalCutOffPrice && roundedFinalCutOffPrice !== roundedFinalPrice;


  return (
    <div className="min-price-box">
      <span className="text-warning fw-bold">Starting from</span> &nbsp;

      {showCutOffPrice  && (
        <>
        <del className="text-white fw-bold">
          {symbol}
          {roundedFinalCutOffPrice.toLocaleString()}
        </del>
         &nbsp;
         &nbsp;
        </>
      )}

      <span className="text-white fw-bold">
        {symbol}
        {roundedFinalPrice.toLocaleString()}
        <span className="ms-1 text-white">
          /{durationLabel.charAt(0).toUpperCase() + durationLabel.slice(1)}
        </span>
      </span>
    </div>
  );
};

export default MinPlanPrice;
